import { useErrorReporter } from "core/hooks/useErrorReporter";
import { addValidationException } from "tasks/actions";
import { useStore } from "tasks/store";

export const useErrorReporterFiltered = () => {
  const { dispatch } = useStore();
  const errorReporter = useErrorReporter();
  return {
    ...errorReporter,
    notify: (error: any) => {
      const isValidationException = error.message.includes("Validation failed");
      if (!isValidationException) {
        errorReporter.notify(error);
      } else {
        dispatch(
          addValidationException(error.message.replace("GraphQL error: ", "")),
        );
      }
    },
  };
};
